import { Season, Waiver } from '@types';
import { RequestApi } from '_helpers';

const getCurrentSeasonDetails = async () => {
  return await RequestApi.get<Season>(`/SeasonDetails/season/current`);
};

const getCurrentWaiver = async () => {
  return await RequestApi.get<Waiver>(`/SeasonDetails/season/waiver`);
};

const seasonDetailsService = {
  getCurrentSeasonDetails,
  getCurrentWaiver,
};

export default seasonDetailsService;
